import { render, staticRenderFns } from "./ClassroomObservationTeacherTaskAssignmentPage.vue?vue&type=template&id=2870d076&scoped=true"
import script from "./ClassroomObservationTeacherTaskAssignmentPage.vue?vue&type=script&lang=js"
export * from "./ClassroomObservationTeacherTaskAssignmentPage.vue?vue&type=script&lang=js"
import style0 from "./ClassroomObservationTeacherTaskAssignmentPage.vue?vue&type=style&index=0&id=2870d076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870d076",
  null
  
)

export default component.exports